import posthog from 'posthog-js';

type EventProperties = Record<string, string | number | boolean | null | undefined>;

let organizationAnalyticsProperties: EventProperties = {};

export const setOrganizationAnalyticsProperties = (properties: EventProperties | null): void => {
  organizationAnalyticsProperties = properties ?? {};
};

const FeatureTrackingService = {
  captureEvent(eventName: string, properties: EventProperties = {}) {
    if (typeof window === 'undefined' || !posthog?.capture) {
      return;
    }

    posthog.capture(eventName, {
      ...organizationAnalyticsProperties,
      ...properties,
    });
  },
};

export default FeatureTrackingService;
